module.exports = require("@swa-ui/dotcom/src/DotcomHeader/DotcomHeaderMobileWithGlobalNav/DotcomHeaderMobileWithGlobalNav.module.scss");